import React, {Component} from 'react';
import '../../App.css';
import KeyStatisticsContent from '../KeyStatisticsContent';

    function KeyStatistics() {
        return (
          <>
              <KeyStatisticsContent />
          </>
        )
      }
    
    export default KeyStatistics;